import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoMessenger = () => {
  return (
    <g>
      <path d="M8 .003C3.703-.112.123 3.227 0 7.466a7.263 7.263 0 0 0 2.896 5.747V16l2.723-1.407A8.53 8.53 0 0 0 8 14.929c4.297.115 7.877-3.225 8-7.463-.123-4.239-3.703-7.578-8-7.463zm.833 10.07-2.1-2.214L2.679 10l4.344-4.57 2.1 2.07 4.053-2.142-4.343 4.714z" />
    </g>
  );
};

export default withIcon(IconLogoMessenger);
